// Player customization storage using localStorage
import { DEFAULT_CUSTOMIZATION, getStyleConfig, getPaletteConfig } from '../config/customization.js';

const STORAGE_KEY = 'boss-game-player-customization';

// Load player customizations from localStorage
export function loadPlayerCustomizations() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            // Validate and merge with defaults
            return {
                1: validateCustomization(parsed[1], 1),
                2: validateCustomization(parsed[2], 2)
            };
        }
    } catch (e) {
        console.warn('Failed to load player customizations:', e);
    }

    // Return defaults if nothing stored or error
    return { ...DEFAULT_CUSTOMIZATION };
}

// Save player customizations to localStorage
export function savePlayerCustomizations(customizations) {
    try {
        const toSave = {
            1: customizations[1] || DEFAULT_CUSTOMIZATION[1],
            2: customizations[2] || DEFAULT_CUSTOMIZATION[2]
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
        return true;
    } catch (e) {
        console.warn('Failed to save player customizations:', e);
        return false;
    }
}

// Save a single player's customization
export function savePlayerCustomization(playerNumber, customization) {
    const all = loadPlayerCustomizations();
    all[playerNumber] = validateCustomization(customization, playerNumber);
    return savePlayerCustomizations(all);
}

// Get customization for a specific player
export function getPlayerCustomization(playerNumber) {
    const all = loadPlayerCustomizations();
    return all[playerNumber] || DEFAULT_CUSTOMIZATION[playerNumber];
}

// Validate customization object, filling in defaults for missing/invalid values
function validateCustomization(custom, playerNumber) {
    const defaults = DEFAULT_CUSTOMIZATION[playerNumber];

    if (!custom || typeof custom !== 'object') {
        return { ...defaults };
    }

    // Validate style exists
    const style = getStyleConfig(custom.style) ? custom.style : defaults.style;

    // Validate palette exists
    const palette = getPaletteConfig(custom.palette) ? custom.palette : defaults.palette;

    // Validate name
    const name = typeof custom.name === 'string' && custom.name.trim()
        ? custom.name.trim().substring(0, 20)  // Limit name length
        : defaults.name;

    return { style, palette, name };
}

// Reset all customizations to defaults
export function resetAllCustomizations() {
    try {
        localStorage.removeItem(STORAGE_KEY);
        return true;
    } catch (e) {
        console.warn('Failed to reset customizations:', e);
        return false;
    }
}

// Check if localStorage is available
export function isStorageAvailable() {
    try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}
